import { handleTokensUpdated } from "./keycloak";
import { getKeycloak } from "./keycloak";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { ToastContainer } from "react-toastify";
import AuthGate from "./AuthGate";
import { handleKeycloakEvent } from "./components/upload/interruptedUpload";

const KeycloakProviderWrapper = () => {
  const onTokensUpdated = (tokens: any) => {
    handleTokensUpdated(tokens);
  };

  const keycloak = getKeycloak();

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onTokens={onTokensUpdated}
      initOptions={{
        // onLoad: "check-sso",
        // silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
        onLoad: "login-required", // Force login immediately
        checkLoginIframe: false, // Disable the login iframe check to avoid unnecessary requests
        pkceMethod: "S256",
        useNonce: false, // the js library checks for nonce on all 3 tokens and its only present on the access token in keycloak server v25+
      }}
      onEvent={(event, error) => {
        // The provider owns the Keycloak instance's hooks (it assigns `onAuthLogout` and
        // the rest in its init) and re-emits each as an event here. `onAuthLogout` is the
        // moment the session is known to be gone and the page is about to navigate to
        // sign-in; an upload in progress is recorded then (AKL-891).
        handleKeycloakEvent(event);
        if (process.env.NODE_ENV === "production") return;
        console.log("[Keycloak Event]:", event);
        if (error) console.error("[Keycloak Error]:", error);
      }}
    >
      <AuthGate />
      <ToastContainer />
    </ReactKeycloakProvider>
  );
};

export default KeycloakProviderWrapper;
